export enum BoardInfoActionType {
    BoardInfoAdd = 'BoardInfoAdd',
    BoardInfoUpdate = 'BoardInfoUpdate',
    BoardInfoDelete = 'BoardInfoDelete',
    BoardInfoSetOrder = 'BoardInfoSetOrder'
}
